import { Checkbox } from '@timelyapp/react';
import DropdownListItem from 'components/DropdownListItem';
import * as constants from 'constants/filters';
import { columnNameFactory } from 'factories/superreports';
import React from 'react';
import type { WidgetWithData } from 'redux/modules/superreports.types';
import { useHandleChangeColumns } from '../table/helpers';

interface Props {
  widget: WidgetWithData;
}

const DonutWidgetOptions: React.FC<Props> = ({ widget }) => {
  const reference = (widget.id || widget._ref)!;
  const columns = widget.columns.names;

  const handleChange = useHandleChangeColumns(columns, reference);

  return (
    <>
      {constants.DONUT_COLUMNS.map(column => {
        const isChecked = columns.includes(column);
        return (
          <DropdownListItem key={column} onClick={() => handleChange(column, !isChecked)}>
            <Checkbox
              id="percentages"
              onChangeChecked={checked => handleChange(column, checked)}
              checked={isChecked}
              label={columnNameFactory(column, widget.widget_type)}
            />
          </DropdownListItem>
        );
      })}
    </>
  );
};

export default DonutWidgetOptions;
